<template>
  <div class="bullet-row">
    <div class="row-head">
      <span class="row-index">#{{ index + 1 }}</span>
      <div class="row-actions">
        <button
          type="button"
          class="row-action-btn"
          :disabled="disabled || index === 0"
          aria-label="Move up"
          title="Move up"
          @click="$emit('move-up', index)"
        >
          <i class="fas fa-arrow-up"></i>
        </button>
        <button
          type="button"
          class="row-action-btn"
          :disabled="disabled || index === total - 1"
          aria-label="Move down"
          title="Move down"
          @click="$emit('move-down', index)"
        >
          <i class="fas fa-arrow-down"></i>
        </button>
        <button
          type="button"
          class="row-action-btn danger"
          :disabled="disabled || total <= 1"
          aria-label="Remove bullet"
          title="Remove bullet"
          @click="$emit('remove', index)"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <div class="row-body">
      <retention-bullet-image-picker
        :image-identifier="bullet.imageIdentifier || ''"
        :disabled="disabled"
        @update:imageIdentifier="onImageChange"
      />
      <retention-bullet-text-fields
        :text="bullet.text || ''"
        :alt-text="bullet.altText || ''"
        :disabled="disabled"
        @update:text="onTextChange"
        @update:altText="onAltTextChange"
      />
    </div>
  </div>
</template>

<script>
import RetentionBulletImagePicker from './BulletImagePicker.vue';
import RetentionBulletTextFields from './BulletTextFields.vue';

export default {
  name: 'RetentionBulletRow',
  components: { RetentionBulletImagePicker, RetentionBulletTextFields },
  props: {
    bullet: { type: Object, required: true },
    index: { type: Number, required: true },
    total: { type: Number, required: true },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    onImageChange(value) {
      this.$emit('update', this.index, { ...this.bullet, imageIdentifier: value });
    },
    onTextChange(value) {
      this.$emit('update', this.index, { ...this.bullet, text: value });
    },
    onAltTextChange(value) {
      this.$emit('update', this.index, { ...this.bullet, altText: value });
    }
  }
};
</script>

<style scoped>
.bullet-row {
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  padding: 0.85rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  transition: border-color 0.12s ease;
}

.bullet-row:focus-within {
  border-color: rgba(3, 179, 218, 0.4);
}

.row-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.row-index {
  font-size: 0.78rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.55);
  letter-spacing: 0.05em;
}

.row-actions {
  display: flex;
  gap: 0.25rem;
}

.row-action-btn {
  width: 26px;
  height: 26px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.03);
  border-radius: 5px;
  color: rgba(255, 255, 255, 0.65);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  transition: all 0.12s ease;
}

.row-action-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  border-color: rgba(255, 255, 255, 0.2);
}

.row-action-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.row-action-btn.danger:hover:not(:disabled) {
  background: rgba(231, 76, 60, 0.18);
  border-color: rgba(231, 76, 60, 0.5);
  color: #ff8a80;
}

.row-body {
  display: flex;
  gap: 0.85rem;
  align-items: stretch;
}

@media (max-width: 600px) {
  .row-body {
    flex-direction: column;
  }
}
</style>
